import { render } from "./CartRow.vue?vue&type=template&id=e631270e&scoped=true"
import script from "./CartRow.vue?vue&type=script&lang=js"
export * from "./CartRow.vue?vue&type=script&lang=js"

import "./CartRow.vue?vue&type=style&index=0&id=e631270e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e631270e"]])

export default __exports__